import React from "react";
import { get, isNil } from "lodash-es";
import Foundation from "@microsoft/fast-components-foundation-react";
import { classNames } from "@microsoft/fast-web-utilities";
import { DisplayNamePrefix } from "../utilities";
import DataGridCell from "./data-grid-cell";
import { DataGridContext } from "./data-grid-context";
class DataGridRow extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            rowData: void 0,
            gridTemplateColumns: void 0,
            rowIndex: void 0,
            managedClasses: void 0,
        };
        /**
         *  renders a cell
         */
        this.renderCell = (column, index) => {
            return (React.createElement(DataGridCell, { key: column.columnDataKey, column: column, rowData: this.props.rowData, columnIndex: index + 1, managedClasses: {
                    dataGridCell: this.props.managedClasses.dataGridRow_cell,
                } }));
        };
    }
    /**
     * Renders the component
     */
    render() {
        if (isNil(this.context)) {
            return null;
        }
        const rowKey = !isNil(this.props.rowData[this.context.dataRowKey])
            ? this.props.rowData[this.context.dataRowKey]
            : this.props.rowIndex;
        // Check if there is already a style object being passed as props
        const styleProps = get(this.props, "style");
        return (React.createElement("div", Object.assign({}, this.unhandledProps(), { role: "row", className: this.generateClassNames(), "data-rowid": rowKey, style: Object.assign({ display: "grid", width: "100%", gridTemplateColumns: this.props.gridTemplateColumns }, styleProps) }), this.renderCells()));
    }
    /**
     * Generates class names
     */
    generateClassNames() {
        const { dataGridRow, dataGridRow__focusedWithin, } = this.props.managedClasses;
        return super.generateClassNames(classNames(dataGridRow, [
            dataGridRow__focusedWithin,
            this.props.rowData[this.context.dataRowKey] === this.context.focusRowKey,
        ]));
    }
    /**
     *  render all cells
     */
    renderCells() {
        if (this.context === null || this.context.columns === null) {
            return;
        }
        return this.context.columns.map(this.renderCell);
    }
}
DataGridRow.defaultProps = {
    managedClasses: {},
};
DataGridRow.displayName = `${DisplayNamePrefix}DataGridRow`;
DataGridRow.contextType = DataGridContext;
DataGridRow.contextType = DataGridContext;
export default DataGridRow;
export * from "./data-grid-row.props";
